import React from "react";
import History from "../History/History";

import "./statistics.scss";

export default function Statistics({
  userData,
  leagueData,
  matches,
  game,
  championsList,
  summoners,
  queueId,
}) {
  return (
    <section className="datacontainer">
      <div className="leagues">
        <div className="rank leagues__solo">
          <div
            style={{
              backgroundImage:
                leagueData.length > 0 &&
                `url(/${leagueData[0].tier}.png)`,
            }}
            className="rank__image rank__image--1"></div>
          <div>
            <h1 className="rank__header">Rank Solo</h1>
            <h1 className="rank__league">
              {leagueData.length > 0
                ? leagueData[0].tier.charAt(0) +
                  leagueData[0].tier.slice(1).toLowerCase() +
                  " " +
                  leagueData[0].rank
                : "Challenger"}
            </h1>
            <h1 className="rank__point">
              <span>
                {leagueData.length > 0
                  ? leagueData[0].leaguePoints
                  : "81"}{" "}
                LP
              </span>{" "}
              / {leagueData.length > 0 ? leagueData[0].wins : "19"}W{" "}
              {leagueData.length > 0 ? leagueData[0].losses : "73"}L
            </h1>
            <h1 className="rank__winrate">
              Win Rate{" "}
              {leagueData.length > 0
                ? Math.round(
                    (leagueData[0].wins /
                      (leagueData[0].wins + leagueData[0].losses)) *
                      100
                  )
                : 80}
              %
            </h1>
            <h1 className="rank__name">Cho Gath's Urfriders</h1>
          </div>
        </div>
        <div className="rank leagues__flex">
          {leagueData.length > 1 ? (
            <>
              {
                <div
                  style={{
                    backgroundImage: `url(/${leagueData[1].tier}.png)`,
                  }}
                  className="rank__image rank__image--2"></div>
              }
              <div>
                <h1 className="rank__header">Flex 5:5 Rank</h1>
                <h1 className="rank__league">
                  {leagueData.length > 1
                    ? leagueData[1].tier.charAt(0) +
                      leagueData[1].tier.slice(1).toLowerCase() +
                      " " +
                      leagueData[1].rank
                    : "Challenger"}
                </h1>
                <h1 className="rank__point">
                  <span>
                    {leagueData.length > 1
                      ? leagueData[1].leaguePoints
                      : 80}{" "}
                    LP
                  </span>{" "}
                  / {leagueData[1].wins}W {" " + leagueData[1].losses}
                  L
                </h1>
                <h1 className="rank__winrate">
                  Win Rate{" "}
                  {leagueData.length > 1
                    ? Math.round(
                        (leagueData[1].wins /
                          (leagueData[1].wins +
                            leagueData[1].losses)) *
                          100
                      )
                    : 80}
                  %
                </h1>
                <h1 className="rank__name">Cho Gath's Urfriders</h1>
              </div>
            </>
          ) : (
            <div></div>
          )}
        </div>
      </div>

      {/* <div className="datas">
        <div className="datas__total">a</div>
        <div className="datas__graph">b</div>
      </div> */}

      <History
        matches={matches}
        game={game}
        queueId={queueId}
        championsList={championsList}
        userData={userData}
        summoners={summoners}
      />
    </section>
  );
}
